import { useQuery } from '@tanstack/react-query';
import styles from './AppFooter.module.css';

export function AppFooter() {
  const q = useQuery({
    queryKey: ['platform', 'public'],
    queryFn: async () => {
      const res = await fetch('/api/platform/public', { credentials: 'include' });
      if (!res.ok) return { privacy: { policy_url: 'https://giovannipira.com/privacy' } };
      return res.json() as Promise<{ privacy: { policy_url: string } }>;
    },
    staleTime: 300_000,
  });
  const url = q.data?.privacy.policy_url ?? 'https://giovannipira.com/privacy';

  return (
    <footer className={styles.footer}>
      <a href={url} target="_blank" rel="noreferrer">
        Privacy
      </a>
      <span aria-hidden="true"> · </span>
      <a href="/app/instellingen/privacy">Security &amp; privacy</a>
    </footer>
  );
}
